import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, reset } from 'redux-form'
import { Button, Icon } from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { RowFields } from 'components'
import { getBGLimitOfBank } from 'ducks/bgLimitOfBank'

const SearchComponent = (props) => {

  const { 
    valueForm,
    companyOptions,
    bankOwnerOptions,
    // props
    pageSize=10
  } = props

  const onReset = () =>{
    props.reset('formSearchBGLimitOfBank')
    props.getBGLimitOfBank({page:1,size:pageSize})
  }

  React.useEffect(()=>{
    if(Object.keys(valueForm).length>0){
      props.getBGLimitOfBank({...valueForm, page:1,size:pageSize})
    }
  },[valueForm])

  return (
    <RowFields>
      <Field 
        name='companyCode' 
        options={companyOptions.data} 
        loading={companyOptions.loading}
        type={type.select} 
        component={FieldInput} 
        placeHolder='All Company'
      />
      <Field 
        name='bankName' 
        options={bankOwnerOptions.data} 
        loading={bankOwnerOptions.loading}
        type={type.select} 
        component={FieldInput} 
        placeHolder='All Bank'
      />
      <Icon type='button' name='search' style={{marginTop:'0.3rem'}} inverted circular link />
      <Button 
        type='button' 
        style={{marginLeft:'1rem',maxHeight:'2.7rem'}} 
        onClick={()=>{onReset()}}>Clear</Button>
    </RowFields>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formSearchBGLimitOfBank')(state) || {},
    companyOptions: state.options.companies,
    bankOwnerOptions: state.bg.bankOwners,
  }
}

const mapDispatchToProps = {
  getBGLimitOfBank,
  reset
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchComponent)
